const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <svg width="200" height="60" viewBox="0 5 200 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Central Hub */}
                <circle cx="30" cy="30" r="8" fill="white"/>
                {/* Connected Nodes */}
                <circle cx="15" cy="15" r="4" fill="white"/>
                <circle cx="45" cy="15" r="4" fill="white"/>
                <circle cx="45" cy="45" r="4" fill="white"/>
                <circle cx="15" cy="45" r="4" fill="white"/>
                <circle cx="30" cy="10" r="4" fill="white"/>
                <circle cx="50" cy="30" r="4" fill="white"/>
                <circle cx="30" cy="50" r="4" fill="white"/>
                <circle cx="10" cy="30" r="4" fill="white"/>
                {/* Connecting Lines */}
                <line x1="30" y1="30" x2="15" y2="15" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="45" y2="15" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="45" y2="45" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="15" y2="45" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="30" y2="10" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="50" y2="30" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="30" y2="50" stroke="white" strokeWidth="2"/>
                <line x1="30" y1="30" x2="10" y2="30" stroke="white" strokeWidth="2"/>
                {/* Text */}
                <text x="70" y="25" fontFamily="Satoshi, Arial, sans-serif" fontSize="24" fontWeight="bold" fill="white">oneAI</text>
                <text x="70" y="42" fontFamily="Satoshi, Arial, sans-serif" fontSize="12" fontWeight="normal" fill="white" letterSpacing="2px">CONSULTING</text>
              </svg>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-md">
              Leading AI agent automation consulting firm. Transform your business with intelligent automation solutions.
            </p>
            <p className="text-gray-400 text-sm">
              The future belongs to AI agents that think, act, and deliver results autonomously.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="/solutions" className="text-gray-300 hover:text-white transition-colors">
                  Solutions
                </a>
              </li>
              <li>
                <a href="/case-studies" className="text-gray-300 hover:text-white transition-colors">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="/blog" className="text-gray-300 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Get In Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-[#212331] rounded-lg flex items-center justify-center mt-0.5">
                  <svg className="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-gray-300">Email</p>
                  <a href="mailto:info@oneaiconsulting.com" className="text-white hover:text-blue-400 transition-colors">
                    info@oneaiconsulting.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-[#212331] rounded-lg flex items-center justify-center mt-0.5">
                  <svg className="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-gray-300">Location</p>
                  <p className="text-white">Global Remote Team</p>
                </div>
              </div>

              {/* Social Links */}
              <div className="pt-4">
                <p className="text-gray-300 mb-3">Follow Us</p>
                <div className="flex space-x-4">
                  <a 
                    href="https://linkedin.com/company/oneai-consulting" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-[#212331] rounded-lg flex items-center justify-center text-white hover:bg-blue-600 transition-colors"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path fillRule="evenodd" clipRule="evenodd" d="M4.5 3C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67157 20.3284 3 19.5 3H4.5ZM8.52076 7.00272C8.52639 7.95897 7.81061 8.54819 6.96123 8.54397C6.16107 8.53975 5.46357 7.90272 5.46779 7.00413C5.47201 6.15897 6.13998 5.47975 7.00764 5.49944C7.88795 5.51913 8.52639 6.1646 8.52076 7.00272ZM12.2797 9.76176H9.75971H9.7583V18.3216H12.4217V18.1219C12.4217 17.742 12.4214 17.362 12.4211 16.9819V16.9818V16.9816V16.9815V16.9812C12.4203 15.9674 12.4194 14.9532 12.4246 13.9397C12.426 13.6936 12.4372 13.4377 12.5005 13.2028C12.7381 12.3253 13.5271 11.7586 14.4074 11.8979C14.9727 11.9864 15.3467 12.3141 15.5042 12.8471C15.6013 13.1803 15.6449 13.5389 15.6491 13.8863C15.6605 14.9339 15.6589 15.9815 15.6573 17.0292V17.0294C15.6567 17.3992 15.6561 17.769 15.6561 18.1388V18.3202H18.328V18.1149C18.328 17.6629 18.3278 17.211 18.3275 16.7591V16.759V16.7588C18.327 15.6293 18.3264 14.5001 18.3294 13.3702C18.3308 12.8597 18.276 12.3563 18.1508 11.8627C17.9638 11.1286 17.5771 10.5211 16.9485 10.0824C16.5027 9.77019 16.0133 9.5691 15.4663 9.5466C15.404 9.54401 15.3412 9.54062 15.2781 9.53721L15.2781 9.53721L15.2781 9.53721C14.9984 9.52209 14.7141 9.50673 14.4467 9.56066C13.6817 9.71394 13.0096 10.0641 12.5019 10.6814C12.4429 10.7522 12.3852 10.8241 12.2991 10.9314L12.2991 10.9315L12.2797 10.9557V9.76176ZM5.68164 18.3244H8.33242V9.76733H5.68164V18.3244Z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; 2024 oneAI Consulting. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
